module.exports = __webpack_public_path__ + "static/media/UK.94f62e30.png";